import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { HttpJsonHeader } from "../../features/Environments";
import { GiDeliveryDrone } from "react-icons/gi";
import { BiSend } from "react-icons/bi";
import { AiFillMessage } from "react-icons/ai";
import { setReminder } from "../../features/UserActions";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";

function RadiComment(props) {
  const [option, setOption] = props?.radiComment;
  const [list, lists] = useState([]);
  const [dataX] = props?.dataX;
  const [params, setParams] = useState({ commentId: 0, remark: "" });

  const handleClose = () => {
    setOption({ show: false });
  };

  const userDetail = useSelector((state) => state.user.detail);
  const dispatch = useDispatch();

  /**Load ตัวเลือก*/
  useEffect(() => {
    if (option?.show) {
      loadCommentList();
    }
    return () => {
      lists([]);
    };
  }, [option?.show]);

  //** list selector item */
  const loadCommentList = (row) => {
    axios
      .post(
        process.env.REACT_APP_API + "api/radicomment/getCommentList",
        {
          StudyInfo: row,
          UserInfo: userDetail,
        },
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data.data) {
          let json = JSON.parse(res?.data?.data);
          lists(json);
        }
      })
      .catch((err) => {});
  };

  const sendMessage = (e) => {
    axios
      .post(
        process.env.REACT_APP_API + "api/radicomment/sendNewComment",
        {
          StudyInfo: { PacsStudyId: dataX?.studyInfo?.pacs_study_id },
          Data: params,
          UserInfo: { UserId: userDetail.userid },
        },
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(
          setReminder({
            show: true,
            message: "แจ้งข้อความไปที่เจ้าหน้าที่แล้ว",
            type: "success",
          })
        );
        setOption({ show: false });
      })
      .catch((err) => {});
  };

  return (
    <MyModal
      show={option.show}
      size="lg"
      backdrop={true}
      centered
      onHide={() => handleClose()}
    >
      <ModalHeaderBlack closeButton closeLabel="closing">
        <div style={{ color: "#09fa09", fontSize: "20px" }}>
          <AiFillMessage style={{ color: "white" }} /> ส่งข้อความแจ้งเตือน
        </div>
      </ModalHeaderBlack>

      <ModalBodyBlack style={{ backgroundColor: "#1d1c1c" }}>
        <CommentList>
          <Form.Label style={{ color: "#ffcc00" }}>
            หัวข้อการแจ้งเตือน
          </Form.Label>
          {list &&
            list.map((item) => (
              <Form.Check
                type="radio"
                id={item?.CommentId}
                label={item?.CommentText}
                checked={item?.CommentId === params.commentId ? true : false}
                onChange={(e) => {
                  if (e.target.checked === true) {
                    setParams((pv) => {
                      return { ...pv, ...{ commentId: Number(e.target.id) } };
                    });
                  }
                }}
              />
            ))}
          <div>
            <Form.Group className="mb-0, mt-3">
              <Form.Label style={{ color: "#ffcc00" }}>รายละเอียด</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                className="m0"
                value={params?.remark}
                onChange={(e) =>
                  setParams((pv) => {
                    return { ...pv, ...{ remark: e.target.value } };
                  })
                }
              ></Form.Control>
            </Form.Group>
          </div>
        </CommentList>
      </ModalBodyBlack>
      <ModalFooterBlack>
        <Button
          style={{ width: "120px" }}
          variant="success"
          onClick={(e) => sendMessage(e)}
        >
          ส่ง <BiSend />{" "}
        </Button>
        <Button variant="danger" onClick={() => handleClose()}>
          ยกเลิก
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}

export default React.memo(RadiComment);

const CommentList = styled.div`
  /* background-color: #1d1c1c; */
  padding: 25px 30px;
  color: #84acfc;
  border-radius: 5px;
`;
